import { numberToLocale } from '@forms/client/AddProductForm/utils';
import { EntityTile } from '@tailwindComponents/EntityTile';
import { Modal } from '@tailwindComponents/Modal';
import {
  ProductGroupListing,
  productGroupName,
} from '@views/SKUMaster/components/productGroups';
import {
  skuCode,
  skuOwnThumbnailSrc,
} from '@views/SKUMaster/components/skuHelpers';
import { availableProductsOf, skusToChooseFrom } from './productDespatch';
import { InventorySKUListing } from './types';

export function ChooseSkuModal({
  group,
  warehouseId,
  isOpen,
  setIsOpen,
  onSelectSku,
  title = 'Choose a SKU',
  action = 'despatch',
}: {
  group: ProductGroupListing;
  warehouseId: string | null | undefined;
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  onSelectSku: (sku: InventorySKUListing) => void;
  title?: string;
  action?: string;
}) {
  const skus = skusToChooseFrom(group, warehouseId);
  const hasUnloadedSkus = skus.length < group.skuCount;

  return (
    <Modal isOpen={isOpen} setIsOpen={setIsOpen} title={title}>
      <div className='w-full sm:w-[28rem]'>
        <p className='text-sm text-gray-600'>
          {productGroupName(group)} holds {numberToLocale(group.skuCount)} SKUs.
          Pick the one to {action}.
        </p>
        <ul className='mt-4 flex flex-col gap-2'>
          {skus.map((sku) => (
            <li key={sku.inventorySkuId}>
              <button
                type='button'
                onClick={() => onSelectSku(sku)}
                className='flex w-full items-center gap-3 rounded-lg border border-gray-200 px-3 py-2 text-left transition-colors hover:border-primary hover:bg-blue-50'
              >
                <EntityTile
                  name={sku.name}
                  imageSrc={skuOwnThumbnailSrc(sku)}
                  size='sm'
                />
                <span className='min-w-0 flex-1'>
                  <span className='block truncate text-sm font-medium text-gray-900'>
                    {sku.name}
                  </span>
                  <span className='block truncate text-xs text-gray-500'>
                    {skuCode(sku)}
                  </span>
                </span>
                <span className='shrink-0 text-sm font-semibold text-green-700'>
                  {numberToLocale(availableProductsOf(sku, warehouseId))}
                  <span className='ml-1 text-xs font-normal text-gray-600'>
                    available
                  </span>
                </span>
              </button>
            </li>
          ))}
        </ul>
        {hasUnloadedSkus && (
          <p className='mt-3 text-xs text-gray-400'>
            Showing {skus.length} of {group.skuCount} SKUs.
          </p>
        )}
      </div>
    </Modal>
  );
}
